import React from 'react';
import './PoliticaPrivacidad.css';

const PoliticaPrivacidad = ({ onBack }) => {
    return (
        <div className="public-page">
            <button className="btn-secondary" onClick={onBack}>
                Volver
            </button>
            <header className="public-page-header">
                <h2>Política de Privacidad</h2>
                <p>Cómo recogemos, usamos y protegemos tu información personal</p>
                <p style={{ fontSize: '0.9rem', color: '#666' }}>
                    Última actualización: Enero 2026
                </p>
            </header>

            <section className="public-page-content">
                <h3>1. INTRODUCCIÓN</h3>
                <p>
                    En LOTEA, tu privacidad es fundamental para nosotros. Esta Política de Privacidad explica
                    cómo recogemos, usamos, divulgamos y protegemos tu información cuando utilizas nuestra plataforma.
                    Te recomendamos que leas esta política cuidadosamente para entender nuestras prácticas de privacidad.
                </p>

                <h3>2. INFORMACIÓN QUE RECOLECTAMOS</h3>

                <h4>2.1 Información de Registro</h4>
                <p>
                    Cuando creas una cuenta en LOTEA, recolectamos:
                </p>
                <ul>
                    <li>Nombre completo</li>
                    <li>Correo electrónico</li>
                    <li>Contraseña (almacenada de forma encriptada)</li>
                    <li>Número de teléfono (opcional)</li>
                    <li>Información de empresa u organización (opcional)</li>
                </ul>

                <h4>2.2 Información de Pago</h4>
                <p>
                    Cuando seleccionas un plan de suscripción, recolectamos:
                </p>
                <ul>
                    <li>Información de tarjeta de crédito/débito (procesada a través de proveedores de pago seguros)</li>
                    <li>Dirección de facturación</li>
                    <li>Historial de transacciones</li>
                </ul>
                <p>
                    <strong>Nota:</strong> LOTEA no almacena directamente números de tarjeta completos. Esta información
                    es procesada por proveedores de pago certificados que cumplen con estándares PCI DSS de seguridad.
                </p>

                <h4>2.3 Información de Proyectos y Contenido</h4>
                <p>
                    Cuando usas LOTEA, recolectamos:
                </p>
                <ul>
                    <li>Información de proyectos y lotes que creas</li>
                    <li>Archivos de planos que cargas</li>
                    <li>Datos y configuraciones de lotización</li>
                    <li>Comentarios y notas asociados a tus proyectos</li>
                </ul>

                <h4>2.4 Información de Uso y Técnica</h4>
                <p>
                    Recolectamos automáticamente información sobre cómo usas LOTEA:
                </p>
                <ul>
                    <li>Dirección IP</li>
                    <li>Tipo de navegador y sistema operativo</li>
                    <li>Páginas visitadas y funciones utilizadas</li>
                    <li>Duración de las sesiones</li>
                    <li>Fecha y hora de acceso</li>
                    <li>Información de dispositivo (tipo, identificador único)</li>
                </ul>

                <h4>2.5 Cookies y Tecnologías Similares</h4>
                <p>
                    LOTEA utiliza cookies y tecnologías similares para:
                </p>
                <ul>
                    <li>Mantener tu sesión activa</li>
                    <li>Recordar tus preferencias</li>
                    <li>Analizar el uso de la plataforma</li>
                    <li>Mejorar la experiencia del usuario</li>
                </ul>
                <p>
                    Puedes controlar las cookies a través de la configuración de tu navegador. Sin embargo,
                    desactivar cookies puede afectar la funcionalidad de LOTEA.
                </p>

                <h3>3. FINALIDAD DEL USO DE INFORMACIÓN</h3>
                <p>Utilizamos tu información para:</p>
                <ul>
                    <li>Crear y mantener tu cuenta</li>
                    <li>Procesar pagos y gestionar tu suscripción</li>
                    <li>Proporcionar el servicio de LOTEA y sus características</li>
                    <li>Comunicarnos contigo sobre tu cuenta, cambios de servicio y soporte técnico</li>
                    <li>Mejorar y optimizar la plataforma</li>
                    <li>Cumplir con obligaciones legales y regulatorias</li>
                    <li>Prevenir fraude y abuso de la plataforma</li>
                    <li>Realizar análisis y estadísticas (de forma anonimizada cuando sea posible)</li>
                    <li>Enviar actualizaciones y promociones (con tu consentimiento)</li>
                </ul>

                <h3>4. COMPARTICIÓN DE INFORMACIÓN</h3>
                <p>
                    <strong>Proveedores de Servicios:</strong> Compartimos información con proveedores terceros
                    necesarios para operar LOTEA, incluyendo:
                </p>
                <ul>
                    <li>Proveedores de hosting y almacenamiento en la nube</li>
                    <li>Procesadores de pago</li>
                    <li>Proveedores de correo electrónico</li>
                    <li>Servicios de análisis</li>
                </ul>
                <p>
                    <strong>Cumplimiento Legal:</strong> Podemos divulgar tu información si es requerido por ley,
                    orden judicial, autoridades gubernamentales o si creemos de buena fe que es necesario para:
                </p>
                <ul>
                    <li>Cumplir la ley o procedimientos legales</li>
                    <li>Proteger nuestros derechos, privacidad, seguridad o propiedad</li>
                    <li>Proteger a otros de daños</li>
                </ul>
                <p>
                    <strong>No Vendemos Datos:</strong> LOTEA NO vende, alquila ni comercia con tu información
                    personal a terceros con fines de marketing.
                </p>

                <h3>5. SEGURIDAD DE DATOS</h3>
                <p>
                    Implementamos medidas técnicas, administrativas y físicas para proteger tu información:
                </p>
                <ul>
                    <li>Encriptación SSL/TLS para transmisión de datos</li>
                    <li>Encriptación de contraseñas mediante algoritmos seguros (bcrypt)</li>
                    <li>Acceso restringido a información personal</li>
                    <li>Monitoreo regular de seguridad</li>
                    <li>Copias de seguridad regulares</li>
                </ul>
                <p>
                    A pesar de estas medidas, ningún método de transmisión por Internet es 100% seguro.
                    LOTEA no puede garantizar seguridad absoluta, aunque se compromete a mantener los más altos estándares.
                </p>

                <h3>6. RETENCIÓN DE DATOS</h3>
                <p>
                    Retenemos tu información personal mientras tu cuenta esté activa. Si cancelas tu suscripción:
                </p>
                <ul>
                    <li>Tu cuenta y datos asociados se marcarán como inactivos</li>
                    <li>Después de 30 días de inactividad, tus datos se eliminarán de forma permanente</li>
                    <li>Los registros de transacciones se conservan según requisitos legales (típicamente 7 años)</li>
                </ul>
                <p>
                    Puedes solicitar la eliminación inmediata de tus datos en cualquier momento contactando al soporte.
                </p>

                <h3>7. DERECHOS DE PRIVACIDAD</h3>
                <p>
                    Tienes derecho a:
                </p>
                <ul>
                    <li><strong>Acceso:</strong> Solicitar una copia de tu información personal</li>
                    <li><strong>Rectificación:</strong> Corregir información inexacta</li>
                    <li><strong>Eliminación:</strong> Solicitar que se eliminen tus datos (derecho al olvido)</li>
                    <li><strong>Portabilidad:</strong> Recibir tus datos en formato estructurado</li>
                    <li><strong>Restricción:</strong> Limitar cómo usamos tu información</li>
                    <li><strong>Objeción:</strong> Objetar el procesamiento de tus datos</li>
                    <li><strong>Consentimiento:</strong> Retirar consentimiento en cualquier momento</li>
                </ul>
                <p>
                    Para ejercer estos derechos, contacta a nuestro equipo de soporte con tu solicitud y verificación
                    de identidad. Responderemos dentro de 30 días.
                </p>

                <h3>8. PERÍODO DE PRUEBA GRATUITO (3 DÍAS)</h3>
                <p>
                    Durante tu período de prueba gratuito de 3 días:
                </p>
                <ul>
                    <li>Tendrás acceso completo a todas las funcionalidades</li>
                    <li>Recolectamos tu información de uso para mejorar el servicio</li>
                    <li>Si no seleccionas un plan después de 3 días, tu acceso será limitado</li>
                    <li>Al convertir a un plan pagado, procesamos tu información de pago</li>
                </ul>

                <h3>9. COMUNICACIONES</h3>
                <p>
                    Podemos enviarte:
                </p>
                <ul>
                    <li><strong>Emails Transaccionales:</strong> Confirmaciones de cuenta, cambios de suscripción (obligatorios)</li>
                    <li><strong>Emails de Soporte:</strong> Respuestas a tus consultas</li>
                    <li><strong>Emails Promocionales:</strong> Sobre nuevas funciones (requieren tu consentimiento)</li>
                </ul>
                <p>
                    Puedes desuscribirse de emails promocionales en cualquier momento mediante el enlace en el email
                    o en tu perfil de usuario.
                </p>

                <h3>10. MENORES DE EDAD</h3>
                <p>
                    LOTEA no está destinado a menores de 13 años. No recolectamos intencionalmente información
                    de menores. Si descubrimos que hemos recolectado datos de un menor, los eliminaremos inmediatamente.
                </p>

                <h3>11. ENLACES A TERCEROS</h3>
                <p>
                    LOTEA puede contener enlaces a sitios web externos. No somos responsables por las prácticas
                    de privacidad de estos sitios. Te recomendamos revisar sus políticas de privacidad antes de proporcionarles información.
                </p>

                <h3>12. CAMBIOS EN ESTA POLÍTICA</h3>
                <p>
                    LOTEA puede actualizar esta Política de Privacidad ocasionalmente. Los cambios significativos
                    serán comunicados a través de:
                </p>
                <ul>
                    <li>Notificación por correo electrónico</li>
                    <li>Aviso destacado en la plataforma</li>
                    <li>Actualización de la fecha Última actualización en esta página</li>
                </ul>
                <p>
                    Tu uso continuado de LOTEA después de cambios constituye aceptación de la política actualizada.
                </p>

                <h3>13. TRANSFERENCIA INTERNACIONAL DE DATOS</h3>
                <p>
                    Tu información puede ser procesada, almacenada y transferida a países diferentes al tuyo,
                    incluyendo países que pueden no tener leyes de protección de datos equivalentes.
                    Al usar LOTEA, consientes a estas transferencias.
                </p>

                <h3>14. CONTACTO</h3>
                <p>
                    Si tienes preguntas, preocupaciones o solicitudes relacionadas con esta Política de Privacidad
                    o nuestras prácticas de privacidad, puedes contactarnos:
                </p>
                <ul>
                    <li>A través de la sección de Soporte en la aplicación LOTEA</li>
                    <li>Por correo electrónico mediante el formulario de contacto</li>
                </ul>
                <p>
                    Nos comprometemos a responder tus consultas en el plazo más breve posible.
                </p>

                <h3>15. CUMPLIMIENTO NORMATIVO</h3>
                <p>
                    LOTEA cumple con las regulaciones aplicables de privacidad de datos, incluyendo
                    GDPR (en Europa) y CCPA (en California), entre otras leyes de protección de datos relevantes.
                </p>
            </section>
        </div>
    );
};

export default PoliticaPrivacidad;